export const PageVisible = {
  homePage: true,
  tradePage: true,
  eOtcPage: true,
  convertPage: true,
  showTickerBar: true,
  account_overviewPage: true,
  account_verificationPage: true,
  account_securityPage: true,
  account_IPWhitelistPage: true,
  account_AffiliatesPage: true,
  account_ApiKeyPage: true,
  account_ExchangeTokenPage: true,
  account_VolumeDiscountPage: true,
  account_ChangePasswordPage: true,
  account_WhitelistDevicesPage: true,
  order_openPage: true,
  order_historyPage: true,
  order_tradeHistoryPage: true,
  order_convertHistoryPage: true,
  wallet_overviewPage: true,
  wallet_depositPage: true,
  wallet_withdrawalPage: true,
  wallet_addressBookPage: true,
  wallet_bankPage: true,
  wallet_convertDustPage: true,
  showPriceBand: true,
  earnCampaign: true,
};
